import React from "react";
import { FaFileAlt } from "react-icons/fa";
import { countClientDocuments } from "./clientDocumentsUtils";

const BTN_CLASS =
  "inline-flex h-8 w-8 items-center justify-center rounded-md border transition focus:outline-none focus:ring-2 focus:ring-offset-1";

function ClientDocumentsButton({
  documents,
  clientName = "Client",
  clientId = null,
  providerId = null,
  appId = null,
  appType = null,
  onOpen,
  className = "",
}) {
  const count = countClientDocuments(documents);

  return (
    <button
      type="button"
      onClick={() =>
        onOpen?.({
          clientName,
          documents: documents || [],
          clientId,
          providerId,
          appId,
          appType,
        })
      }
      title={
        count > 0
          ? `View ${count} document${count === 1 ? "" : "s"}`
          : "No documents uploaded"
      }
      aria-label={`View documents for ${clientName}`}
      className={`${BTN_CLASS} relative border-slate-200 bg-white text-slate-600 hover:border-[#007BFF]/30 hover:bg-[#007BFF]/5 hover:text-[#007BFF] focus:ring-[#007BFF]/30 ${
        count === 0 ? "opacity-60" : ""
      } ${className}`}
      style={{ boxShadow: "none" }}
    >
      <FaFileAlt size={14} />
      {count > 0 ? (
        <span className="absolute -right-1 -top-1 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-[#007BFF] px-1 text-[9px] font-bold text-white">
          {count > 99 ? "99+" : count}
        </span>
      ) : null}
    </button>
  );
}

export default ClientDocumentsButton;
